type FooterLinksGroup = {
  name: string;
  links: {
    href: string;
    name: string;
    includeSubdomain?: boolean;
  }[];
}[];

const SITE_FOOTER_LINKS: FooterLinksGroup = [
  {
    name: "Tools",
    links: [
      {
        href: "/assignment-calculator",
        name: "Assignment calendar",
      },
      {
        href: "/thesis-statement-generator",
        name: "Thesis statement generator",
      },
      {
        href: "/conclusion-generator",
        name: "Conclusion generator",
      },
      {
        href: "/words-to-pages-converter",
        name: "Words to pages converter",
      },
      {
        href: "/title-page-generator",
        name: "Title page generator",
      },
    ],
  },
  {
    name: "Company",
    links: [
      {
        name: "FAQ",
        href: "/faq",
        includeSubdomain: true,
      },
      {
        name: "About us",
        href: "/about-us",
        includeSubdomain: true,
      },
      {
        name: "Contact us",
        href: "/contacts",
        includeSubdomain: true,
      },
      {
        name: "Donate a paper",
        href: "/donate-essay",
      },
      {
        href: "/dmca-inquiry",
        name: "DMCA inquiry",
      },
      {
        href: "/sitemap",
        name: "Sitemap",
      },
    ],
  },
];

const LEGAL_LINKS = {
  name: "Legal",
  links: [
    {
      name: "Terms & conditions",
      href: "/terms-and-conditions",
      includeSubdomain: true,
    },
    {
      name: "Privacy policy",
      href: "/privacy-policy",
      includeSubdomain: true,
    },
    {
      name: "Money-back guarantee",
      href: "/money-back-guarantee",
      includeSubdomain: true,
    },
    {
      name: "Cookies policy",
      href: "/cookies-policy",
      includeSubdomain: true,
    },
    {
      name: "Fair use",
      href: "/fair-use-policy",
      includeSubdomain: true,
    },
    {
      name: "Plagiarism & AI Policy",
      href: "/plagiarism-and-ai-policy",
      includeSubdomain: true,
    },
  ],
};

const WRITER_SERVICE_FOOTER_LINKS: FooterLinksGroup = [
  {
    name: "Company",
    links: [
      {
        href: "/about-us",
        name: "About us",
        includeSubdomain: true,
      },
      {
        href: "/faq",
        name: "FAQ",
        includeSubdomain: true,
      },
      {
        href: "/contacts",
        name: "Contact us",
        includeSubdomain: true,
      },
      {
        href: "/dmca-inquiry",
        name: "DMCA inquiry",
      },
    ],
  },
  {
    name: "Free resources",
    links: [
      {
        href: "/search",
        name: "Free essay samples",
      },
      {
        href: "/tools",
        name: "Free tools",
      },
    ],
  },
];

export const getFooterLinks = (isWritingService: boolean): FooterLinksGroup => [
  ...(isWritingService ? WRITER_SERVICE_FOOTER_LINKS : SITE_FOOTER_LINKS),
  LEGAL_LINKS,
];
